(function(){
  'use strict';
  console.log('[BBV2] script running');

  /* === Config (inherits from existing wizard, embedded directly) === */
  const CDN_BASE = 'https://chronoslab.es/cdn/hats/SAPKA/';
  const BENCH_EDIT_CDN = 'https://chronoslab.es/cdn/patches/BENCH_EDIT/';
  const PATCH_PRICE = 12;
  function hatImageUrl(sku, ext) {
    var cat = HAT_CATEGORIES[sku] || "";
    return CDN_BASE + (cat ? cat + "/" : "") + sku + (ext || ".jpg");
  }


  const MODEL_NAMES = {
    'A-3100':'Béisbol Clásico','A-3200':'Cordura F.S.','A-3400':'Béisbol Niños','A-3500':'Béisbol Premium',
    'A-3510':'Béisbol Premium 6P','A-7100':'Trucker Clásico','A-7200':'Cordura',
    'A-7410':'Trucker Niños','A-7500':'Trucker Premium'
  };

  const HAT_PRICES = {
    'A-3100':39,'A-3200':49,'A-3400':39,'A-3500':49,'A-3510':49,
    'A-7100':39,'A-7200':69,'A-7410':39,'A-7500':49
  };

  const CATEGORY_LABELS = {
    'BEYZBOL':'Beisbol',
    'TRUCKER':'Trucker',
    'TRUCKER_CLASSIC':'Classic',
    'CORDURA_FILELI':'Cordura',
    'CORDURA_FILESIZ':'Cord. F.S.'
  };

  const BENCH_EDIT_HATS = ["A-3500-010101","A-3500-020202","A-3500-030303","A-3500-090909","A-3500-101010","A-3500-102929","A-3500-120212","A-3500-121212","A-3500-131313","A-3500-141414","A-3500-152929","A-3500-171717","A-3500-191919","A-3500-202020","A-3500-290101","A-3500-290202","A-3500-290303","A-3500-291010","A-3500-292020","A-3500-292929","A-3500-293434","A-3500-303030","A-7200-031717","A-7200-101029","A-7200-171703","A-7200-171717","A-7200-171728","A-7200-291010","A-7200-291029","A-7200-292903","A-7200-292910","A-7200-292914","A-7200-292925","A-7200-292928","A-7200-292929","A-7200-293729","A-7200-372929","A-7200-373729","A-3200-101010","A-3200-171717","A-3200-292929","A-3200-373737","A-7100-131329","A-7100-171717","A-7500-010128","A-7500-020229","A-7500-030303","A-7500-030329","A-7500-032929","A-7500-101029","A-7500-121229","A-7500-131329","A-7500-141403","A-7500-141428","A-7500-142929","A-7500-152929","A-7500-171703","A-7500-171717","A-7500-290129","A-7500-290303","A-7500-290329","A-7500-290929","A-7500-291029","A-7500-291429","A-7500-292029","A-7500-292910","A-7500-292914","A-7500-292925","A-7500-292929","A-7500-293429","A-7100-040404","A-7100-171704","A-7100-171717","A-7100-242924","A-7100-292928"];
  const HAT_CATEGORIES = {"A-3500-010101":"BEYZBOL","A-3500-020202":"BEYZBOL","A-3500-030303":"BEYZBOL","A-3500-090909":"BEYZBOL","A-3500-101010":"BEYZBOL","A-3500-102929":"BEYZBOL","A-3500-120212":"BEYZBOL","A-3500-121212":"BEYZBOL","A-3500-131313":"BEYZBOL","A-3500-141414":"BEYZBOL","A-3500-152929":"BEYZBOL","A-3500-171717":"BEYZBOL","A-3500-191919":"BEYZBOL","A-3500-202020":"BEYZBOL","A-3500-290101":"BEYZBOL","A-3500-290202":"BEYZBOL","A-3500-290303":"BEYZBOL","A-3500-291010":"BEYZBOL","A-3500-292020":"BEYZBOL","A-3500-292929":"BEYZBOL","A-3500-293434":"BEYZBOL","A-3500-303030":"BEYZBOL","A-7200-031717":"CORDURA_FILELI","A-7200-101029":"CORDURA_FILELI","A-7200-171703":"CORDURA_FILELI","A-7200-171717":"CORDURA_FILELI","A-7200-171728":"CORDURA_FILELI","A-7200-291010":"CORDURA_FILELI","A-7200-291029":"CORDURA_FILELI","A-7200-292903":"CORDURA_FILELI","A-7200-292910":"CORDURA_FILELI","A-7200-292914":"CORDURA_FILELI","A-7200-292925":"CORDURA_FILELI","A-7200-292928":"CORDURA_FILELI","A-7200-292929":"CORDURA_FILELI","A-7200-293729":"CORDURA_FILELI","A-7200-372929":"CORDURA_FILELI","A-7200-373729":"CORDURA_FILELI","A-3200-101010":"CORDURA_FILESIZ","A-3200-171717":"CORDURA_FILESIZ","A-3200-292929":"CORDURA_FILESIZ","A-3200-373737":"CORDURA_FILESIZ","A-7100-131329":"TRUCKER","A-7100-171717":"TRUCKER_CLASSIC","A-7500-010128":"TRUCKER","A-7500-020229":"TRUCKER","A-7500-030303":"TRUCKER","A-7500-030329":"TRUCKER","A-7500-032929":"TRUCKER","A-7500-101029":"TRUCKER","A-7500-121229":"TRUCKER","A-7500-131329":"TRUCKER","A-7500-141403":"TRUCKER","A-7500-141428":"TRUCKER","A-7500-142929":"TRUCKER","A-7500-152929":"TRUCKER","A-7500-171703":"TRUCKER","A-7500-171717":"TRUCKER","A-7500-290129":"TRUCKER","A-7500-290303":"TRUCKER","A-7500-290329":"TRUCKER","A-7500-290929":"TRUCKER","A-7500-291029":"TRUCKER","A-7500-291429":"TRUCKER","A-7500-292029":"TRUCKER","A-7500-292910":"TRUCKER","A-7500-292914":"TRUCKER","A-7500-292925":"TRUCKER","A-7500-292929":"TRUCKER","A-7500-293429":"TRUCKER","A-7100-040404":"TRUCKER_CLASSIC","A-7100-171704":"TRUCKER_CLASSIC","A-7100-242924":"TRUCKER_CLASSIC","A-7100-292928":"TRUCKER_CLASSIC"};
  const EXCLUDED_HAT_PREFIXES=[];
  const EXCLUDED_HAT_SKUS=[];
  const AVAILABLE_HATS = BENCH_EDIT_HATS.filter(s => !EXCLUDED_HAT_PREFIXES.some(p => s.startsWith(p)) && !EXCLUDED_HAT_SKUS.includes(s));

  /* Color code → name (from the SAPKA SKU last segment) */
  const COLOR_CODES = {
    '02':{name:'Negro',hex:'#0a0a0a'},
    '03':{name:'Gris Oscuro',hex:'#444'},
    '04':{name:'Gris',hex:'#888'},
    '05':{name:'Gris Claro',hex:'#bbb'},
    '10':{name:'Beige',hex:'#d6c4a3'},
    '14':{name:'Marrón',hex:'#7a4a2a'},
    '15':{name:'Camel',hex:'#c9a47a'},
    '17':{name:'Camel Cl.',hex:'#dab48a'},
    '19':{name:'Arena',hex:'#d8c39c'},
    '20':{name:'Naranja',hex:'#e8732e'},
    '24':{name:'Khaki',hex:'#7c7253'},
    '25':{name:'Azul Marino',hex:'#1a2c50'},
    '26':{name:'Azul',hex:'#2956b3'},
    '28':{name:'Azul Cielo',hex:'#7faedb'},
    '29':{name:'Blanco',hex:'#f0f0f0'},
    '30':{name:'Rojo',hex:'#c12c2c'},
    '33':{name:'Verde',hex:'#2a6e3f'},
    '34':{name:'Verde Osc.',hex:'#1b4d2a'},
    '35':{name:'Verde Cl.',hex:'#7ab279'},
  };

  /* Parse SKU like A-7500-292914 → primaryColor='29', secondaryColor='29', tertiary='14' */
  function parseColors(sku){
    const last = sku.split('-').pop();
    if (!last || last.length < 2) return [];
    const codes = [];
    for (let i = 0; i < last.length; i += 2) {
      const c = last.substr(i, 2);
      if (COLOR_CODES[c] && !codes.includes(c)) codes.push(c);
    }
    return codes;
  }

  const BENCH_EDIT_PATCHES_LIST = ["10-001-189","10-002-189","10-005-189","10-006-189","10-009-189","10-010-189","10-014-189","10-015-189","10-015-879","10-017-889","10-019-189","10-021-189","10-022-189","10-023-189","10-024-129","10-025-189","10-026-189","10-027-189","10-028-189","10-029-189","10-030-189","10-031-189","10-032-189","10-033-189","10-034-189","10-035-819","10-037-189","10-038-189","10-039-189","11-001-188","11-001-811","11-001-881","11-001-888","11-002-129","11-002-189","11-004-889","11-007-188","11-007-881","11-008-188","11-011-811","11-011-881","11-013-889","11-019-189","11-020-289","11-021-189","12-001-188","12-001-811","12-002-811","12-003-188","12-007-188","12-009-188","12-009-811","12-010-188","12-012-188","12-012-811","12-013-188","12-014-188","12-014-811","12-015-188","12-017-811","12-021-188","12-021-811","12-023-188","12-023-811","12-024-811","12-026-188","12-026-811","12-027-188","12-027-811","12-028-188","12-028-811","12-030-811","12-031-811","12-032-811","12-033-811","12-034-811","12-035-811","12-036-811","12-037-811","12-038-811","12-039-811","12-040-811","12-041-811","12-042-188","12-043-188","12-043-811","12-044-188","12-044-811","12-045-188","12-046-188","12-046-811","12-047-188","12-049-188","12-049-811","12-050-188","12-050-811","12-054-811","12-056-188","13-001-189","13-003-189","13-003-889","13-004-889","13-005-189","13-006-189","13-007-189","13-008-188","13-009-129","13-009-189","13-010-189","13-013-189","13-014-189","13-015-189","13-017-881","13-018-189","13-018-889","13-019-189","13-020-189","13-021-189","13-022-189","13-023-589","13-024-189","13-024-819","13-024-889","13-025-288","13-026-189","13-027-189","13-027-881","13-028-811","13-028-821","13-028-881","13-029-288","13-030-188","13-031-189","13-032-189","13-034-189","13-035-189","13-036-189","13-037-811","13-038-189","13-039-881","13-039-889","13-040-288","13-041-881","13-042-288","13-042-881","13-044-881","13-045-189","13-046-189","13-047-889","13-048-189","13-049-189","13-050-189","13-051-188","13-052-188","13-053-189","13-055-189","13-056-189","13-057-189","13-059-889","13-060-889","13-061-889","13-062-189","13-063-188","13-064-189","13-066-189","13-067-189","13-068-189","13-069-189","13-070-189","13-072-819","13-072-889","13-073-881","13-074-189","13-075-189","13-076-189","13-077-881","13-079-189","13-080-189","13-081-189","13-082-889","13-083-189","13-084-189","13-085-189","13-086-189","13-087-189","13-088-189","13-089-819","13-090-188","13-091-189","13-092-189","13-093-189","13-094-288","14-001-189","14-002-589","14-003-189","14-004-889","14-005-189","14-006-189","14-008-819","14-009-889","14-011-189","14-012-189","14-016-189","14-017-188","14-018-189","14-019-189","14-020-189","14-021-887","14-025-189","14-026-189","14-027-189","14-028-189","14-029-189","14-030-189","14-031-189","14-032-119","14-033-119","14-034-119","14-035-119","14-036-119","14-037-189","14-038-189","14-039-189","14-040-119","14-041-119","14-042-189","16-001-189","16-002-189","16-003-189","16-004-189","16-005-189","16-006-189","16-007-189","17-001-811","17-001-866","17-002-188","17-002-189","17-003-182","17-003-188","17-003-189","17-003-289","17-003-819","17-003-859","17-004-819","17-005-288","17-005-811","17-005-881","17-005-888","17-006-881","17-007-811","17-007-881","17-008-811","17-009-189","17-010-886","17-011-185","17-012-811","17-012-881","17-013-811","17-014-188","17-014-866","17-014-881","17-015-288","17-016-188","17-016-811","17-016-881","17-016-887","17-017-881","17-019-188","17-019-811","17-020-188","17-020-811","17-020-881","17-021-188","17-022-188","17-023-188","17-023-811","17-023-881","17-024-889","17-026-811","17-029-889","17-030-811","17-031-189","17-032-881","17-033-811","17-033-881","17-035-881","17-036-188","17-036-887","17-037-189","17-038-889","17-039-881","17-040-889","17-041-889","17-042-881","17-043-188","17-043-887","17-044-881","17-045-188","17-046-811","17-049-811","17-050-811","17-050-887","17-051-881","17-052-189","17-055-887","17-056-811","17-058-881","17-061-866","17-061-885","17-064-881","17-065-81N","17-066-811","17-069-188","17-070-189","17-071-188","17-073-811","17-074-811","17-075-811","17-076-811","17-077-811","17-078-189","17-082-888","18-040-188"];
  const BENCH_EDIT_PATCHES = new Set(BENCH_EDIT_PATCHES_LIST);

  /* === STATE === */
  const state = {
    selectedHat: null, selectedPatch: null,
    hatVariantId: null, patchVariantId: null,
    hatPrice: 0,
    hats: [], patches: [],
    activeType: 'all', activeColor: null, hatSearch: '',
    activeCat: 'all', patchSearch: '',
    currentStep: 1,
  };

  const $ = id => document.getElementById(id);

  /* === BENCH_EDIT probe — uses HEAD fetch (chronoslab serves access-control-allow-origin:*) */
  async function probeBenchEdit(sku){
    const url = BENCH_EDIT_CDN + sku + '.png';
    try {
      const ctrl = new AbortController();
      const t = setTimeout(() => ctrl.abort(), 6000);
      const r = await fetch(url, { method: 'HEAD', signal: ctrl.signal, cache: 'force-cache' });
      clearTimeout(t);
      if (!r.ok) return false;
      const ct = (r.headers.get('content-type') || '').toLowerCase();
      const len = parseInt(r.headers.get('content-length') || '0', 10);
      if (!ct.startsWith('image/')) return false;
      if (len > 0) return true;
      return await new Promise(resolve => {
        const img = new Image();
        let done = false;
        const finish = ok => { if (!done){ done = true; resolve(ok); } };
        img.onload = () => finish(img.naturalWidth > 0 && img.naturalHeight > 0);
        img.onerror = () => finish(false);
        setTimeout(() => finish(false), 5000);
        img.src = url;
      });
    } catch(e){ return false; }
  }

  async function filterPatchesByBenchEdit(patches){
    const BATCH = 12;
    const valid = [];
    for (let i = 0; i < patches.length; i += BATCH){
      const slice = patches.slice(i, i + BATCH);
      const results = await Promise.all(slice.map(p => probeBenchEdit(p.sku)));
      slice.forEach((p, idx) => { if (results[idx]) valid.push(p); });
      state.patches = valid.slice();
      renderPatchGrid();
    }
    return valid;
  }

  /* === LOAD products from Shopify === */
  async function loadAll(){
    let allProducts = [];
    let page = 1;
    while (page <= 10){
      try{
        const r = await fetch(`/products.json?limit=250&page=${page}`);
        const d = await r.json();
        if (!d.products || d.products.length === 0) break;
        allProducts = allProducts.concat(d.products);
        if (d.products.length < 250) break;
        page++;
      } catch(e){ break; }
    }
    /* Hat extraction */
    const setHats = new Set(AVAILABLE_HATS);
    const productPrices = {};
    allProducts.forEach(p => {
      (p.variants||[]).forEach(v => {
        const sku = v.sku||'';
        if (sku.startsWith('A-') && sku.length > 20){
          const m = sku.substring(0,6);
          if (!productPrices[m]) productPrices[m] = parseFloat(v.price);
        }
      });
    });
    const hats = [];
    allProducts.forEach(p => {
      const imgs = p.images||[];
      (p.variants||[]).forEach(v => {
        const sku = v.sku||'';
        if (setHats.has(sku)){
          const img = imgs.find(i => i.variant_ids && i.variant_ids.includes(v.id));
          if (img){
            const model = sku.split('-').slice(0,2).join('-');
            const price = parseFloat(v.price) || productPrices[model] || HAT_PRICES[model] || 39;
            const inStock = v.available && (v.inventory_management === null || v.inventory_quantity == null || v.inventory_quantity > 0);
            hats.push({
              id: p.id, variantId: v.id, title: p.title, sku, model, price,
              available: !!inStock, inventoryQty: v.inventory_quantity,
              image: hatImageUrl(sku), benchEditImage: BENCH_EDIT_CDN+sku+'.png',
              colors: parseColors(sku),
            });
          }
        }
      });
    });
    /* Fallback: add hats from AVAILABLE_HATS that don't have Shopify variants yet */
    const foundSkus = new Set(hats.map(h => h.sku));
    AVAILABLE_HATS.forEach(sku => {
      if (!foundSkus.has(sku)) {
        const model = sku.split('-').slice(0,2).join('-');
        hats.push({
          id: null, variantId: null, title: sku, sku, model,
          price: HAT_PRICES[model] || 39,
          available: false, inventoryQty: 0,
          image: hatImageUrl(sku), benchEditImage: BENCH_EDIT_CDN+sku+'.png',
          colors: parseColors(sku),
        });
      }
    });

    /* Patches — only in BENCH_EDIT list, in stock, with shop image */
    const candidates = allProducts
      .filter(p => BENCH_EDIT_PATCHES.has((p.variants||[])[0]?.sku||''))
      .map(p => {
        const v = p.variants[0];
        return {
          id: p.id, variantId: v.id, title: p.title, sku: v.sku||'',
          price: PATCH_PRICE, comparePrice: parseFloat(v.price),
          image: (p.images||[])[0]?.src||'', available: v.available,
          inventoryQty: v.inventory_quantity, inventoryMgmt: v.inventory_management,
        };
      })
      .filter(p => p.available && p.image &&
        (p.inventoryMgmt === null || p.inventoryQty == null || p.inventoryQty > 0));

    state.hats = hats;
    state.patches = [];
    renderHatGrid();
    updateChipCounts();
    /* Show loading state while probing BENCH_EDIT files */
    const grid = $('bbv2-patchgrid');
    if (grid) grid.innerHTML = '<div class="bbv2-empty">Cargando parches con vista previa…</div>';
    /* Probe BENCH_EDIT URLs and filter */
    await filterPatchesByBenchEdit(candidates);
    console.log('[BBV2] valid bench-edit patches:', state.patches.length, '/', candidates.length);
  }

  /* === COLOR SWATCHES === */
  function renderColorSwatches(){ /* disabled — color swatches removed per user request */ }

  function updateChipCounts(){
    const setCnt = (id, fn) => { const el = $(id); if (el) el.textContent = '('+state.hats.filter(fn).length+')'; };
    setCnt('cnt-all', () => true);
    Object.keys(CATEGORY_LABELS).forEach(cat => {
      setCnt('cnt-'+cat, h => HAT_CATEGORIES[h.sku] === cat);
    });
  }

  /* === HAT GRID === */
  function filteredHats(){
    let list = state.hats;
    if (state.activeType !== 'all'){
      list = list.filter(h => HAT_CATEGORIES[h.sku] === state.activeType);
    }
    if (state.activeColor){
      list = list.filter(h => h.colors.includes(state.activeColor));
    }
    if (state.hatSearch){
      const q = state.hatSearch.toLowerCase();
      list = list.filter(h => h.title.toLowerCase().includes(q) || h.sku.toLowerCase().includes(q) ||
        h.colors.some(c => (COLOR_CODES[c]?.name||'').toLowerCase().includes(q)) ||
        (MODEL_NAMES[h.model]||'').toLowerCase().includes(q) ||
        (CATEGORY_LABELS[HAT_CATEGORIES[h.sku]]||'').toLowerCase().includes(q));
    }
    return list;
  }

  function renderHatGrid(){
    const list = filteredHats();
    const grid = $('bbv2-hatgrid');
    if (list.length === 0){
      grid.innerHTML = '<div class="bbv2-empty">No hay gorras con estos filtros. Prueba otra combinación.</div>';
      return;
    }
    grid.innerHTML = list.map(h => `
      <div class="bbv2-prod ${state.selectedHat?.sku === h.sku ? 'selected' : ''} ${!h.available ? 'oos' : ''}" data-sku="${h.sku}">
        <img loading="lazy" src="${h.image}" alt="${h.title}" onerror="this.src='${hatImageUrl(h.sku, '.png')}'">
        <span class="price">€${Math.round(h.price)}</span>
      </div>
    `).join('');
    grid.querySelectorAll('.bbv2-prod').forEach(el => el.addEventListener('click', () => {
      const sku = el.dataset.sku;
      const hat = state.hats.find(h => h.sku === sku);
      if (!hat) return;
      state.selectedHat = hat;
      state.hatVariantId = hat.variantId;
      state.hatPrice = hat.price;
      grid.querySelectorAll('.bbv2-prod').forEach(x => x.classList.remove('selected'));
      el.classList.add('selected');
      $('bbv2-next1').disabled = false;
      enableStep(2);
      updatePreview();
      updateBasket();
    }));
  }

  /* === PATCH GRID === */
  function filteredPatches(){
    let list = state.patches;
    if (state.activeCat !== 'all') list = list.filter(p => p.sku.startsWith(state.activeCat));
    if (state.patchSearch){
      const q = state.patchSearch.toLowerCase();
      list = list.filter(p => p.title.toLowerCase().includes(q) || p.sku.toLowerCase().includes(q));
    }
    return list;
  }

  function renderPatchGrid(){
    const list = filteredPatches();
    const grid = $('bbv2-patchgrid');
    if (list.length === 0){
      grid.innerHTML = '<div class="bbv2-empty">No hay parches con estos filtros.</div>';
      return;
    }
    grid.innerHTML = list.map(p => `
      <div class="bbv2-prod ${state.selectedPatch?.sku === p.sku ? 'selected' : ''}" data-sku="${p.sku}" title="${p.title}">
        <img loading="lazy" src="${p.image}" alt="${p.title}" onerror="this.style.display='none'">
        <span class="price" style="background:var(--bb-success)">GRATIS</span>
      </div>
    `).join('');
    grid.querySelectorAll('.bbv2-prod').forEach(el => el.addEventListener('click', () => {
      const sku = el.dataset.sku;
      const patch = state.patches.find(p => p.sku === sku);
      if (!patch) return;
      state.selectedPatch = patch;
      state.patchVariantId = patch.variantId;
      grid.querySelectorAll('.bbv2-prod').forEach(x => x.classList.remove('selected'));
      el.classList.add('selected');
      updatePreview();
      updateBasket();
    }));
  }

  /* === PREVIEW === */
  function updatePreview(){
    const empty = $('bbv2-stagent'), cap = $('bbv2-cap'), ov = $('bbv2-overlay'), patch = $('bbv2-patch'), stage = $('bbv2-stage');
    const sideEl = document.querySelector('.bbv2-side');
    if (!state.selectedHat){
      empty.style.display = ''; cap.style.display = 'none'; ov.style.display = 'none';
      stage.classList.remove('oos');
      if (sideEl) sideEl.setAttribute('data-empty', 'true');
      updateStockBanner();
      return;
    }
    if (sideEl) sideEl.setAttribute('data-empty', 'false');
    empty.style.display = 'none';
    cap.src = state.selectedHat.image;
    cap.style.display = '';
    if (state.selectedPatch){
      showBenchEditOverlay();
    } else {
      ov.style.display = 'none';
    }
    /* Toggle out-of-stock state on the stage */
    const oos = !state.selectedHat.available;
    stage.classList.toggle('oos', oos);
    updateStockBanner();
  }

  function updateStockBanner(){
    const meta = $('bbv2-stage-meta');
    if (!meta) return;
    if (state.selectedHat && !state.selectedHat.available){
      meta.classList.add('oos');
      meta.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg> <span><b>Agotado</b> · Esta combinación no está disponible</span>';
    } else {
      meta.classList.remove('oos');
      meta.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> <span>Envío <b>inmediato</b> · Stock disponible · Devolución gratuita 14 días</span>';
    }
  }

  function showBenchEditOverlay(){
    const ov = $('bbv2-overlay'), patch = $('bbv2-patch');
    if (!state.selectedHat || !state.selectedPatch || !ov || !patch){
      if (ov) ov.style.display = 'none';
      return;
    }
    const url = BENCH_EDIT_CDN + state.selectedPatch.sku + '.png';
    ov.style.display = 'block';
    patch.src = url;
    patch.alt = state.selectedPatch.title;
  }

  /* === BASKET === */
  function updateBasket(){
    $('bbv2-c-cap').textContent = state.selectedHat ? (MODEL_NAMES[state.selectedHat.model]||state.selectedHat.model) : 'No seleccionada';
    $('bbv2-c-cap-p').textContent = state.selectedHat ? '€'+state.hatPrice.toFixed(0) : '€0';
    $('bbv2-c-patch').textContent = state.selectedPatch ? state.selectedPatch.title : 'No seleccionado';
    $('bbv2-c-patch-p').textContent = state.selectedHat && state.selectedPatch ? 'GRATIS' : (state.selectedPatch ? '€'+PATCH_PRICE : 'GRATIS*');
    const total = state.selectedHat ? state.hatPrice : (state.selectedPatch ? PATCH_PRICE : 0);
    $('bbv2-total').textContent = '€'+total.toFixed(0);
    /* Disable cart button if hat OOS or no Shopify variant */
    const canAdd = !!(state.selectedHat && state.selectedPatch && state.selectedHat.available && state.selectedHat.variantId);
    const btn = $('bbv2-addbtn');
    btn.disabled = !canAdd;
    if (state.selectedHat && !state.selectedHat.available){
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg> Agotado';
    } else {
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Añadir al Carrito';
    }
  }

  /* === STEPPER === */
  function enableStep(n){
    document.querySelectorAll('.bbv2-step').forEach(s => {
      const idx = parseInt(s.dataset.go);
      if (idx <= n) s.disabled = false;
    });
  }
  function goStep(n){
    state.currentStep = n;
    document.querySelectorAll('.bbv2-step').forEach(s => {
      const idx = parseInt(s.dataset.go);
      s.classList.toggle('active', idx === n);
      s.classList.toggle('done', idx < n);
    });
    document.querySelectorAll('.bbv2-pane').forEach(p => {
      p.classList.toggle('active', parseInt(p.dataset.pane) === n);
    });
    window.scrollTo({top: document.querySelector('.bbv2-stepper').offsetTop - 80, behavior: 'smooth'});
  }

  /* === ADD TO CART === */
  async function addToCart(){
    const btn = $('bbv2-addbtn');
    const original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span style="display:inline-block;width:16px;height:16px;border:2px solid rgba(255,255,255,.3);border-top-color:#fff;border-radius:50%;animation:bbv2-spin .8s linear infinite"></span> Añadiendo…';
    try{
      const bundleId = 'B'+Date.now().toString(36);
      const items = [
        { id: state.hatVariantId, quantity: 1, properties: { _combo_type:'gorra_con_parche', _bundle_id: bundleId, _patch_name: state.selectedPatch.title, _patch_sku: state.selectedPatch.sku } },
        { id: state.patchVariantId, quantity: 1, properties: { _combo_type:'parche_con_gorra', _bundle_id: bundleId, _hat_sku: state.selectedHat.sku, _parche_incluido: 'GRATIS' } },
      ];
      const r = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items}) });
      if (!r.ok){ const e = await r.json(); throw new Error(e.description||'Error'); }
      btn.innerHTML = '✓ Añadido al carrito · Redirigiendo…';
      btn.style.background = 'var(--bb-success)';
      setTimeout(() => window.location.href = '/cart', 1000);
    } catch(e){
      alert(e.message || 'Error añadiendo al carrito');
      btn.innerHTML = original;
      btn.disabled = false;
    }
  }

  /* === EVENTS === */
  document.querySelectorAll('.bbv2-step').forEach(s => s.addEventListener('click', () => {
    if (s.disabled) return;
    goStep(parseInt(s.dataset.go));
  }));
  document.querySelectorAll('#bbv2-typechips .bbv2-chip').forEach(c => c.addEventListener('click', () => {
    document.querySelectorAll('#bbv2-typechips .bbv2-chip').forEach(x => x.classList.remove('active'));
    c.classList.add('active');
    state.activeType = c.dataset.type;
    renderHatGrid();
  }));
  document.querySelectorAll('#bbv2-patchchips .bbv2-chip').forEach(c => c.addEventListener('click', () => {
    document.querySelectorAll('#bbv2-patchchips .bbv2-chip').forEach(x => x.classList.remove('active'));
    c.classList.add('active');
    state.activeCat = c.dataset.cat;
    renderPatchGrid();
  }));
  $('bbv2-hatsearch').addEventListener('input', e => { state.hatSearch = e.target.value; renderHatGrid(); });
  $('bbv2-patchsearch').addEventListener('input', e => { state.patchSearch = e.target.value; renderPatchGrid(); });
  $('bbv2-next1').addEventListener('click', () => goStep(2));
  $('bbv2-back2').addEventListener('click', () => goStep(1));
  /* Step 3 (Customize) removed — next2/skipcust no longer exist */
  $('bbv2-addbtn').addEventListener('click', addToCart);

  /* Boot */
  console.log('[BBV2] calling loadAll'); loadAll().then(()=>console.log('[BBV2] loadAll done, hats:', state.hats.length)).catch(e=>console.error('[BBV2] loadAll FAIL:', e));
})();
